import React from 'react';

const InfoIcon = () =>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="6" stroke="#1575C3" />
    <path
      d="M6.32935 4.30514C6.32935 3.87954 6.55157 3.66675 6.99601 3.66675C7.44046 3.66675 7.66268 3.87954 7.66268 4.30514C7.66268 4.50794 7.60645 4.66646 7.494 4.78072C7.38423 4.89211 7.21823 4.94781 6.99601 4.94781C6.55157 4.94781 6.32935 4.73359 6.32935 4.30514ZM7.60645 10.3334H6.38155V5.54335H7.60645V10.3334Z"
      fill="#1575C3"
    />
  </svg>;

export default InfoIcon;



// WEBPACK FOOTER //
// ./src/shared/components/Icons/InfoIcon.js